// Import Observable
import { Observable } from 'rxjs';

// Import Firebase and AngularFire
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PersistentStorageService } from './persistent-storage.service';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {
	// The authentiction information of the user signed in.
	public authInfo: Observable<firebase.User>;

	constructor(
		private readonly afAuth: AngularFireAuth,
		private readonly persistentStorageService: PersistentStorageService
	) {
		this.authInfo = this.afAuth.authState;
	}

	/**
   * @description method to authenticate the user based on the service selected.
   * Note: The authentication service can be anything. (microsoft.com, google.com... etc).
   * It can be configured.
   */
	login(successCallback) {
		const provider = new firebase.auth.OAuthProvider(environment.authService);
		this.afAuth.auth.signInWithRedirect(provider).then((user) => {
			successCallback(user);
		});
	}

	/**
   * @description method to logout the user based on the service selected.
   */
	async logout() {
		this.afAuth.auth.signOut().then(
			() => {
				sessionStorage.removeItem('auth_token');
				sessionStorage.removeItem('token');
				this.persistentStorageService.removeLocalStorage('template_id');
      			window.location.href = `${window.location.origin}/log-out.html`;
			},
			(error) => {
				console.log(error);
			}
		);
	}
}
